import { ColorName, Icon, Text } from "@zapier/design-system";

import styles from "./SidebarListItem.module.css";
import { ClearSelectionButton } from "./ClearSelectionButton";
import classNames from "classnames";

export function SidebarListItem({
  color,
  label,
  onRemove,
  icon,
  isViewOnly,
}: {
  color?: ColorName;
  label: string;
  onRemove: (() => void) | undefined;
  icon?: React.ReactNode;
  isViewOnly?: boolean;
}) {
  const listItemStyles = classNames(styles.listItem, {
    [styles.viewOnly]: isViewOnly,
  });
  return (
    <li className={listItemStyles}>
      {icon || (
        <Icon name="personCircleFill" color={color || "GrayWarm3"} size={26} />
      )}
      <div className={styles.truncateText}>
        <Text type="SmallPrint2">{label}</Text>
      </div>
      {onRemove && <ClearSelectionButton clearSelection={onRemove} />}
    </li>
  );
}
